import successImg from './../../assets/img/successImg.svg';
import classes from './ConfirmationModal.module.css';

import close from '../../assets/img/closeIcon.svg';

const ConfirmationModal = (props) => {
  return (
    <div className={classes.confirmationModal}>
      <div className={classes.success__block_img}>
        <img className={classes.success__modal_img} src={successImg} />
      </div>
      <div className={classes.text_block}>
        <div className={classes.title}>{props.title}</div>
        <div className={classes.text}>{props.msg}</div>
      </div>
      {props.onClose && (
        <div onClick={props.onClose} className={classes.closeBtn}>
          <img src={close} alt="X" />
        </div>
      )}
    </div>
  );
};

export default ConfirmationModal;
